import { render } from "./HeaderWrapper.vue?vue&type=template&id=01977e70&scoped=true"
import script from "./HeaderWrapper.vue?vue&type=script&lang=js"
export * from "./HeaderWrapper.vue?vue&type=script&lang=js"

import "./HeaderWrapper.vue?vue&type=style&index=0&id=01977e70&scoped=true&lang=scss"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01977e70"]])

export default __exports__